import * as React from "react";
const SvgChef = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M10.49 3.012A2.496 2.496 0 0 1 12.5 2c.824 0 1.554.399 2.01 1.013A2.25 2.25 0 0 1 16 7.12V10.5a3.5 3.5 0 1 1-7 0V7.118a2.25 2.25 0 0 1 1.49-4.105Zm.01 7.488a2 2 0 0 0 4 0v-1h-4v1Zm2-7a1 1 0 0 0-.935.645.75.75 0 0 1-1.006.419.75.75 0 1 0-.556 1.393.75.75 0 0 1 .497.706V8h4V6.665c0-.318.2-.602.5-.707a.75.75 0 1 0-.556-1.393.75.75 0 0 1-1.008-.419A1 1 0 0 0 12.5 3.5ZM12.5 22c-3.19 0-6-2.206-6-5.182v-.068c0-.966.784-1.75 1.75-1.75h8.5c.966 0 1.75.784 1.75 1.75v.068c0 2.976-2.81 5.182-6 5.182ZM8 16.75v.068c0 1.73 1.536 3.333 3.75 3.632v-2.284a.75.75 0 0 1 .201-.51l1.076-1.156H8.25a.25.25 0 0 0-.25.25Zm7.076-.25-1.826 1.962v1.988c2.214-.3 3.75-1.902 3.75-3.632v-.068a.25.25 0 0 0-.25-.25h-1.674Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgChef;
